import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { getWeekString } from 'day8-react/build/helpers/booking';
import { IoCalendarClearOutline } from "@react-icons/all-files/io5/IoCalendarClearOutline";
import {
  clearFilter,
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

const Week = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedFilters = getSelectedFilters(history.location);
  const selectedYears = selectedFilters[FILTERS.YEAR];
  // Get all weeks filtered by selected year
  // const filteredWeeks = props.weeks.filter(week =>
  //   +selectedFilters[FILTERS.YEAR][0] ? new Date(week.beginDate).getFullYear() === +selectedFilters[FILTERS.YEAR][0] : true
  // );
  const filteredWeeks = props.weeks;

  // Group weeks by year
  const weeksByYear = filteredWeeks.reduce((acc, week) => {
    if (!acc[new Date(week.beginDate).getFullYear()]) {
      acc[new Date(week.beginDate).getFullYear()] = [];
    }
    acc[new Date(week.beginDate).getFullYear()].push(week);
    return acc;
  }, {});

  // Get unique weeks for each year
  const uniqueWeeksByYear = Object.keys(weeksByYear).reduce((acc, year) => {
    acc[year] = [...new Map(weeksByYear[year].map(item => ([item.beginDate, item]))).values()];
    return acc;
  }, {});

  // Format week options for each year
  const formattedWeeksByYear = Object.keys(uniqueWeeksByYear).reduce((acc, year) => {
    acc[year] = uniqueWeeksByYear[year]
      .sort((a, b) => new Date(a.beginDate) - new Date(b.beginDate))
      .map(week => ({ week: week.week, date: getWeekString(week), year: new Date(week.beginDate).getFullYear().toString() }));
    return acc;
  }, {});

  const selectedFilterText = selectedFilters[FILTERS.WEEK].map(item => item).join(', ');

  // const handleClearFilter = () => {
  //   clearFilter(props.dispatch, props.filterAction, FILTERS.WEEK_CONFIRM);
  //   clearFilter(props.dispatch, props.filterAction, FILTERS.WEEK);
  // };
  const handleIsWeekSelected = item => {
    if (selectedYears.length > 0 && !selectedYears.includes(item.year)) {
      return false;
    }
    return isFilterSelected(history.location, FILTERS.WEEK, item.week);
  };
  const handleWeekSelect = item => {
    clearFilter(dispatch, props.filterAction, FILTERS.YEAR);
    onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.WEEK, item.week);
    onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.YEAR, item.year);
  };
  return props.mobile ? (
    <div className={props.className}>
      {/* <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Week</h3> */}
      {Object.keys(formattedWeeksByYear).length > 1 ? (
        // If there are multiple years, display sections
        Object.keys(formattedWeeksByYear).map(year => (
          <div key={year} className="dui-mb-6">
            <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>WEEK (season {year})</h3>
            <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-2'>
              {selectedYears.length > 0 && !selectedYears.includes(year) ? (
                <div className="dui-flex dui-flex-col dui-gap-2">
                  <p>To view weeks for {year}, please change the year.</p>
                  <div>
                    <Button buttonType="FILTER" onClick={() => {
                      clearFilter(dispatch, props.filterAction, FILTERS.YEAR);
                      onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.YEAR, year);
                    }}>
                      {year}
                    </Button>
                  </div>
                </div>
              ) : (
                formattedWeeksByYear[year].map(item => {
                  return (
                    <Button
                      key={JSON.stringify(item)}
                      buttonType={handleIsWeekSelected(item) ? 'FILTER_ACTIVE' : 'FILTER'}
                      onClick={() => handleWeekSelect(item)}
                    >
                      {item.week} ({item.date})
                    </Button>
                  );
                })
              )}
            </div>
          </div>
        ))
      ) : (
        // If there's only one year, display as before
        <div>
          <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Week</h3>
          <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
            {Object.values(formattedWeeksByYear)[0]?.map(item => (
              <Button
                key={JSON.stringify(item)}
                buttonType={handleIsWeekSelected(item) ? 'FILTER_ACTIVE' : 'FILTER'}
                onClick={() => handleWeekSelect(item)}
              >
                {item.week} ({item.date})
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoCalendarClearOutline />}>{selectedFilterText || 'Week'}</Button>;
};

Week.propTypes = {
  weeks: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterAction: PropTypes.func.isRequired,
  filterModalToggle: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default Week;
